import React from 'react';
import { Link } from 'gatsby';
import styles from '@utils/styles';
import styled from 'styled-components';
import LazyLoad from 'react-lazyload';
import breakpoints from '@repo/ui-components/breakpoints';

const Topics = styled.div`
  display: grid;
  grid-template: 1fr / 1fr;
  grid-gap: 0.625rem;
  margin-bottom: 15px;
  @media (min-width: ${breakpoints.sm}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: ${breakpoints.md}) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1.5625rem;
  }
  @media (min-width: ${breakpoints.lg}) {
    margin-bottom: 60px;
  }
`;

const TopicCategory = styled.div`
  padding: 0.625rem 0;
  text-align: center;
  @media (min-width: ${breakpoints.lg}) {
    font-size: ${styles.fontSize['1xl']};
  }
`;

const TopicLink = styled(Link)`
  text-decoration: none;
  font-weight: ${styles.fontWeight.semiBold};
  color: ${styles.colors.blue[100]};
  &:hover ${TopicCategory} {
    color: ${styles.colors.orange[500]};
    transition: color 0.3s ease;
  }
`;

const ResponsiveImage = styled.img`
  max-width: 100%;
  width: 100%;
  height: auto;
`;

const Topic = styled.div``;

const BASE_URL = '/blog/tag';

const PopularTopics = () => (
  <Topics>
    <Topic>
      <TopicLink to={`${BASE_URL}/health`}>
        <LazyLoad height="100%">
          <ResponsiveImage
            src="/images/articles/health-nutrition.jpg"
            alt="Health &amp; Nutrition"
            width="393"
            height="302"
          />
        </LazyLoad>
        <TopicCategory>Health &amp; Nutrition</TopicCategory>
      </TopicLink>
    </Topic>
    <Topic>
      <TopicLink to={`${BASE_URL}/mud`}>
        <LazyLoad height="100%">
          <ResponsiveImage
            src="/images/articles/muddy-dogs.jpg"
            alt="Muddy Dogs"
            width="393"
            height="302"
          />
        </LazyLoad>
        <TopicCategory>Muddy Dogs</TopicCategory>
      </TopicLink>
    </Topic>
    <Topic>
      <TopicLink to={`${BASE_URL}/running`}>
        <LazyLoad height="100%">
          <ResponsiveImage
            src="/images/articles/running-with-dog.jpg"
            alt="Running with Your Dog"
            width="393"
            height="302"
          />
        </LazyLoad>
        <TopicCategory>Running with Your Dog</TopicCategory>
      </TopicLink>
    </Topic>
    <Topic>
      <TopicLink to={`${BASE_URL}/work`}>
        <LazyLoad height="100%">
          <ResponsiveImage
            src="/images/articles/bring-dog-to-work.jpg"
            alt="Bring Your Dog to Work"
            width="393"
            height="302"
          />
        </LazyLoad>
        <TopicCategory>Bring Your Dog to Work</TopicCategory>
      </TopicLink>
    </Topic>
    <Topic>
      <TopicLink to={`${BASE_URL}/hiking`}>
        <LazyLoad height="100%">
          <ResponsiveImage
            src="/images/articles/hiking-camping.jpg"
            alt="Hiking &amp; Camping"
            width="393"
            height="302"
          />
        </LazyLoad>
        <TopicCategory>Hiking &amp; Camping</TopicCategory>
      </TopicLink>
    </Topic>
    <Topic>
      <TopicLink to={`${BASE_URL}/travel`}>
        <LazyLoad height="100%">
          <ResponsiveImage
            src="/images/articles/pet-travel.jpg"
            alt="Pet Travel"
            width="393"
            height="302"
          />
        </LazyLoad>
        <TopicCategory>Pet Travel</TopicCategory>
      </TopicLink>
    </Topic>
  </Topics>
);

export default PopularTopics;
